import styled, { css } from 'styled-components';
import { isGlobetrotter } from '../../../utils/theming.js';

var Title = styled.div.withConfig({
  displayName: "Titlestyle__Title",
  componentId: "sc-lor2nk-0"
})(["white-space:pre-wrap;font:var(--font-headline-m);", ""], isGlobetrotter(css(["font:var(--font-headline-s);"])));
var TitleLink = styled.a.withConfig({
  displayName: "Titlestyle__TitleLink",
  componentId: "sc-lor2nk-1"
})(["color:var(--color-text);display:inline-flex;text-align:left;&:focus-visible{outline-offset:3px;}&::before{content:'';position:absolute;bottom:0;left:0;width:100%;height:100%;z-index:2;}"]);

export { Title, TitleLink };
//# sourceMappingURL=Title.style.js.map
